// If tuple, just take the text part
export function getTextOfAnswer(answer) {
  if (Array.isArray(answer)) return answer[0];

  return answer && typeof answer === "object" && answer.text
    ? answer.text
    : answer;
}
